import { render, staticRenderFns } from "./PriceListV1.vue?vue&type=template&id=35b7c44c&scoped=true"
import script from "./PriceListV1.vue?vue&type=script&lang=js"
export * from "./PriceListV1.vue?vue&type=script&lang=js"
import style0 from "./PriceListV1.vue?vue&type=style&index=0&id=35b7c44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7c44c",
  null
  
)

export default component.exports